// extracted by mini-css-extract-plugin
export default {"content":"MainPage_content__QA0yO","join":"MainPage_join__w5gDW","error":"MainPage_error__qmwmp","loading":"MainPage_loading__pj92t"};